import { render, staticRenderFns } from "./huifang_list.vue?vue&type=template&id=0876da1b&scoped=true&"
import script from "./huifang_list.vue?vue&type=script&lang=js&"
export * from "./huifang_list.vue?vue&type=script&lang=js&"
import style0 from "./huifang_list.vue?vue&type=style&index=0&id=0876da1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876da1b",
  null
  
)

export default component.exports